var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section", staticStyle: { padding: "13px 20px 10px 20px" } },
    [
      _c(
        "el-form",
        {
          attrs: {
            disabled: !_vm.isEdit,
            inline: true,
            "label-width": _vm.isZh ? "80px" : "120px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.Oversea") } },
            [
              _c(
                "el-select",
                {
                  attrs: { no: "oversea", clearable: "" },
                  model: {
                    value: _vm.form.oversea,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "oversea", $$v)
                    },
                    expression: "form.oversea"
                  }
                },
                [
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.internal"),
                      value: "internal"
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.overseas"),
                      value: "oversea"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form",
        {
          attrs: {
            disabled: !_vm.isEdit,
            inline: true,
            "label-width": _vm.isZh ? "80px" : "140px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticStyle: { display: "flex" },
              attrs: { label: _vm.$t("CargoMsg.Cargo_CurrencyRequirements") }
            },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { no: "currencyRequirements" },
                  model: {
                    value: _vm.form.currencyRequirements,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "currencyRequirements", $$v)
                    },
                    expression: "form.currencyRequirements"
                  }
                },
                [
                  _c(
                    "el-radio",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: { no: "notSpecified", label: 1 }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_NotSpecified")))]
                  ),
                  _c("el-radio", { attrs: { no: "appoint", label: 2 } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Appoint")))
                  ]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100px" },
                      attrs: {
                        no: "appointCurrency",
                        clearable: "",
                        filterable: ""
                      },
                      model: {
                        value: _vm.form.appointCurrency,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "appointCurrency", $$v)
                        },
                        expression: "form.appointCurrency"
                      }
                    },
                    _vm._l(_vm.currencyList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.code }
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-radio",
                    {
                      staticStyle: { "padding-left": "20px" },
                      attrs: { no: "originalCurrency", label: 3 }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CargoMsg.Cargo_PaymentInOriginalCurrency")
                        ) + " "
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "span",
                { staticStyle: { "padding-left": "30px" } },
                [
                  _c("svg-icon", {
                    staticStyle: { "font-size": "14px", "margin-top": "-3px" },
                    attrs: { slot: "reference", "icon-class": "question" },
                    slot: "reference"
                  })
                ],
                1
              ),
              _c("span", { staticStyle: { color: "red" } }, [
                _vm._v(_vm._s(_vm.$t("Message.CreateBill")))
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form",
        {
          attrs: {
            disabled: !_vm.isEdit,
            inline: true,
            "label-width": _vm.isZh ? "80px" : "120px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Payment.invoicingMethod") } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { no: "invoiceMode" },
                  model: {
                    value: _vm.form.invoiceMode,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "invoiceMode", $$v)
                    },
                    expression: "form.invoiceMode"
                  }
                },
                [
                  _c(
                    "el-radio",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: { no: "invoicingPerBill", label: 0 }
                    },
                    [_vm._v(_vm._s(_vm.$t("Partners.invoicingPerBill")))]
                  ),
                  _c(
                    "el-radio",
                    { attrs: { no: "invoicingPerMonth", label: 1 } },
                    [_vm._v(_vm._s(_vm.$t("Partners.invoicingPerMonth")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "custom" },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { no: "overInvoicing" },
                  model: {
                    value: _vm.form.overInvoicing,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "overInvoicing", $$v)
                    },
                    expression: "form.overInvoicing"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Partners.canOverPrice")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form",
        {
          attrs: {
            disabled: !_vm.isEdit,
            inline: true,
            "label-width": _vm.isZh ? "80px" : "120px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("Payment.sellerInvoiceTitle") }
            },
            [
              _c("cargo-advance-select", {
                staticStyle: { width: "300px" },
                attrs: {
                  filterable: true,
                  "filter-type": "global",
                  "filter-tag-names": ["invoiceTitle"],
                  "default-value": _vm.form.sellerTaxAccount,
                  "static-options": _vm.sellerInvoiceTitleOptions,
                  cache: false,
                  "tag-name": "invoiceTitle",
                  "tag-value": "taxAccount",
                  disabled: !_vm.isEdit
                },
                on: { parentCallBack: _vm.handleSellerInvoiceTitleChange }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form",
        {
          attrs: {
            disabled: !_vm.isEdit,
            inline: true,
            "label-width": _vm.isZh ? "80px" : "120px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("Partners.invoicingNote") }
            },
            [
              _c("el-input", {
                staticStyle: { width: "500px" },
                attrs: { no: "invoiceRemarks", type: "textarea", rows: 5 },
                model: {
                  value: _vm.form.invoiceRemarks,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "invoiceRemarks", $$v)
                  },
                  expression: "form.invoiceRemarks"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("span", { staticClass: "title" }, [
        _vm._v(
          _vm._s(
            _vm.isZh ? "税率-发票类型配置" : "Tax Rate - Invoice Type Config"
          )
        )
      ]),
      _c("div", { staticClass: "grid-view" }, [
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            {
              staticClass: "operations",
              staticStyle: { "margin-top": "5px", "margin-bottom": "5px" }
            },
            [
              _c("div", { staticClass: "triggers" }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: !_vm.isEdit,
                          type: "primary",
                          size: "small"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showTaxInvoiceDialog(true)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: !_vm.isEdit,
                          type: "primary",
                          size: "small"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showTaxInvoiceDialog(false)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: !_vm.isEdit,
                          type: "danger",
                          size: "small"
                        },
                        on: { click: _vm.removeTaxInvoice }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                    )
                  ],
                  1
                )
              ])
            ]
          ),
          _c(
            "div",
            { staticClass: "grid-wrapper" },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.taxInvoiceList,
                    border: "",
                    size: "mini",
                    height: "200",
                    "highlight-current-row": ""
                  },
                  on: {
                    "current-change": function(row) {
                      return (_vm.taxInvoiceCurrentRow = row)
                    }
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("Partners.taxRate"),
                      prop: "taxRate",
                      width: "300"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              " " + _vm._s(_vm.getTaxRateLabel(scope.row)) + " "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_InvoiceType"),
                      prop: "invoiceType"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.getInvoiceTypeLabel(scope.row)) +
                                " "
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.taxInvoiceEditDialog.visible,
            title: _vm.taxInvoiceEditDialog.title,
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.taxInvoiceEditDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "100px", "label-position": "left" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Partners.taxRate"), required: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { no: "taxRate" },
                      on: { change: _vm.taxRateChangeHandler },
                      model: {
                        value: _vm.taxInvoiceEditDialog.form.taxRate,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.taxInvoiceEditDialog.form,
                            "taxRate",
                            $$v
                          )
                        },
                        expression: "taxInvoiceEditDialog.form.taxRate"
                      }
                    },
                    _vm._l(_vm.taxRateOptions, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_InvoiceType"),
                    required: ""
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { no: "invoiceType" },
                      on: { change: _vm.invoiceTypeChangeHandler },
                      model: {
                        value: _vm.taxInvoiceEditDialog.form.invoiceType,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.taxInvoiceEditDialog.form,
                            "invoiceType",
                            $$v
                          )
                        },
                        expression: "taxInvoiceEditDialog.form.invoiceType"
                      }
                    },
                    _vm._l(_vm.taxInvoiceTypeOptions, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.saveTaxInvoice }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.taxInvoiceEditDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("span", { staticClass: "title" }, [
        _vm._v(
          _vm._s(
            _vm.$t("CargoMsg.Cargo_InvoicingInformation") +
              _vm.$t("CargoMsg.Cargo_list")
          )
        )
      ]),
      _c("div", { staticClass: " grid-view" }, [
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            {
              staticClass: "operations",
              staticStyle: { "margin-top": "5px", "margin-bottom": "5px" }
            },
            [
              _c("div", { staticClass: "triggers" }, [
                _c(
                  "div",
                  [
                    !this.showIfRisk
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              no: "new",
                              disabled: !_vm.isEdit,
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.showEditDialog(true)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "edit",
                          disabled: !_vm.isEdit,
                          type: "primary"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showEditDialog(false)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                    ),
                    !this.showIfRisk
                      ? _c(
                          "el-button",
                          {
                            attrs: { disabled: !_vm.isEdit, type: "danger" },
                            on: { click: _vm.remove }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                        )
                      : _vm._e(),
                    _vm.jydToFinanceApi
                      ? _c(
                          "el-button",
                          {
                            attrs: { disabled: _vm.isEdit, type: "primary" },
                            on: { click: _vm.pushAddCustomer }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_PushAddCustomer"))
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          ),
          _c(
            "div",
            { staticClass: "grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "101404",
                  "grid-params": _vm.girdParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.girdParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.girdParams = $event
                  }
                }
              })
            ],
            1
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_InvoicingInformation"),
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "145px", "label-position": "left" } },
                [
                  _vm.jydToFinanceApi && _vm.editDialog.form.uuid
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_CustomerCode")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "financeCode" },
                            on: {
                              blur: function($event) {
                                return _vm.deleteTrim("financeCode")
                              }
                            },
                            model: {
                              value: _vm.editDialog.form.financeCode,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "financeCode",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.financeCode"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.invoiceHeader") } },
                    [
                      _c("el-input", {
                        attrs: { no: "title", disabled: _vm.oujianEditLimit },
                        on: {
                          blur: function($event) {
                            return _vm.deleteTrim("title")
                          }
                        },
                        model: {
                          value: _vm.editDialog.form.title,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "title", $$v)
                          },
                          expression: "editDialog.form.title"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.registrationNumber") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "taxAccount",
                          disabled: _vm.oujianEditLimit
                        },
                        model: {
                          value: _vm.editDialog.form.taxAccount,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "taxAccount", $$v)
                          },
                          expression: "editDialog.form.taxAccount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.invoiceAddress") } },
                    [
                      _c("el-input", {
                        attrs: { no: "address" },
                        model: {
                          value: _vm.editDialog.form.address,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "address", $$v)
                          },
                          expression: "editDialog.form.address"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Tel") } },
                    [
                      _c("el-input", {
                        attrs: { no: "telephone" },
                        model: {
                          value: _vm.editDialog.form.telephone,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "telephone", $$v)
                          },
                          expression: "editDialog.form.telephone"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_DepositBankAndAccountNo")
                      }
                    },
                    [
                      _c("cargo-rich-textarea", {
                        ref: "depositBankAccount",
                        staticStyle: { "min-height": "90px" },
                        attrs: {
                          no: "depositBankAccount",
                          "text-chars": 0,
                          "warning-count": -1
                        },
                        model: {
                          value: _vm.editDialog.form.depositBankAccount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.editDialog.form,
                              "depositBankAccount",
                              $$v
                            )
                          },
                          expression: "editDialog.form.depositBankAccount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Invoice.invoice_invoiceCategory")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "invoiceMakeType", clearable: "" },
                          on: { change: _vm.invoiceMakeTypeChangeHandler },
                          model: {
                            value: _vm.editDialog.form.invoiceMakeType,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.editDialog.form,
                                "invoiceMakeType",
                                $$v
                              )
                            },
                            expression: "editDialog.form.invoiceMakeType"
                          }
                        },
                        _vm._l(_vm.invoiceMakeTypes, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_InvoiceType") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "invoiceType", clearable: "" },
                          model: {
                            value: _vm.editDialog.form.invoiceType,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "invoiceType", $$v)
                            },
                            expression: "editDialog.form.invoiceType"
                          }
                        },
                        _vm._l(_vm.invoiceTypes, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.CustomerMailbox") } },
                    [
                      _c("el-input", {
                        attrs: { no: "email" },
                        model: {
                          value: _vm.editDialog.form.email,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "email", $$v)
                          },
                          expression: "editDialog.form.email"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.isDefault") } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "defaultTitle" },
                          on: { change: _vm.onDefaultChange },
                          model: {
                            value: _vm.editDialog.form.defaultTitle,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "defaultTitle", $$v)
                            },
                            expression: "editDialog.form.defaultTitle"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            { attrs: { no: "yes", label: true } },
                            [_vm._v(_vm._s(_vm.$t("Message.Yes")))]
                          ),
                          _c(
                            "el-radio",
                            { attrs: { no: "no", label: false } },
                            [_vm._v(_vm._s(_vm.$t("Message.No")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticStyle: { display: "flex" },
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("Partners.autoEmailSettings")) +
                            " "
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "light",
                              content: _vm.$t(
                                "Partners.partnerInvoiceReminder"
                              ),
                              placement: "bottom-start"
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: {
                                cursor: "pointer",
                                "padding-top": "2px",
                                "padding-right": "2px"
                              },
                              attrs: {
                                src: _vm.iconQuestion,
                                width: "15",
                                height: "15"
                              }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticStyle: { display: "flex" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("Partners.taxControlPlatformSending")
                              ) +
                              " "
                          ),
                          _c("el-checkbox", {
                            staticStyle: { "margin-left": "10px" },
                            attrs: { no: "platformAutoSend" },
                            model: {
                              value: _vm.editDialog.form.platformAutoSend,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "platformAutoSend",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.platformAutoSend"
                            }
                          })
                        ],
                        1
                      ),
                      _c("cargo-advance-select", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editDialog.form.platformAutoSend,
                            expression: "editDialog.form.platformAutoSend"
                          }
                        ],
                        attrs: {
                          no: "platformEmailSendTo",
                          "static-options": _vm.emailSendObjs,
                          "tag-value": "code",
                          clearable: false,
                          "default-value":
                            _vm.editDialog.form.platformEmailSendTo
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.editDialog.form.platformEmailSendTo = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticStyle: { display: "flex" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("Partners.systemAutomaticSending")
                              ) +
                              " "
                          ),
                          _c("el-checkbox", {
                            staticStyle: { "margin-left": "10px" },
                            attrs: { no: "autoSend" },
                            model: {
                              value: _vm.editDialog.form.autoSend,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "autoSend", $$v)
                              },
                              expression: "editDialog.form.autoSend"
                            }
                          })
                        ],
                        1
                      ),
                      _c("cargo-advance-select", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editDialog.form.autoSend,
                            expression: "editDialog.form.autoSend"
                          }
                        ],
                        attrs: {
                          no: "defaultEmailSendTo",
                          "static-options": _vm.emailSendObjs,
                          "tag-value": "code",
                          clearable: false,
                          "default-value":
                            _vm.editDialog.form.defaultEmailSendTo
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.editDialog.form.defaultEmailSendTo = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Oversea") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "oversea", clearable: "" },
                          model: {
                            value: _vm.editDialog.form.oversea,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "oversea", $$v)
                            },
                            expression: "editDialog.form.oversea"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.internal"),
                              value: "internal"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.overseas"),
                              value: "oversea"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticStyle: { display: "flex" },
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("Information.ApplicableWhtTax")) +
                            " "
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t(
                                "Information.ApplicableWhtTaxTip"
                              ),
                              placement: "right"
                            }
                          },
                          [
                            _c("svg-icon", {
                              staticStyle: { "font-size": "16px" },
                              attrs: { "icon-class": "question" }
                            })
                          ],
                          1
                        ),
                        _c("el-checkbox", {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { no: "suitWhtTax" },
                          model: {
                            value: _vm.editDialog.form.suitWhtTax,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "suitWhtTax", $$v)
                            },
                            expression: "editDialog.form.suitWhtTax"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_InvoicingRequirements")
                      }
                    },
                    [
                      _c("el-input", {
                        ref: "invoiceDemand",
                        attrs: {
                          no: "invoiceDemand",
                          type: "textarea",
                          maxlength: 256,
                          rows: 5,
                          clearable: true
                        },
                        model: {
                          value: _vm.editDialog.form.invoiceDemand,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "invoiceDemand", $$v)
                          },
                          expression: "editDialog.form.invoiceDemand"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.saveTemporary }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.bankDialog.visible,
            title: _vm.$t("Partners.bankOfInvoiceHeader"),
            width: "800px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.bankDialog, "visible", $event)
            }
          }
        },
        [
          _c("title-bank-form", {
            ref: "titleBankForm",
            attrs: {
              title: _vm.bankDialog.title,
              "show-if-risk": _vm.showIfRisk
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.pushAddCustomerDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_PushAddCustomer"),
            width: "350px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.pushAddCustomerDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { padding: "20px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_ChooseArea") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "areaCode" },
                          on: { change: _vm.invoiceMakeTypeChangeHandler },
                          model: {
                            value: _vm.pushAddCustomerDialog.areaCode,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.pushAddCustomerDialog,
                                "areaCode",
                                $$v
                              )
                            },
                            expression: "pushAddCustomerDialog.areaCode"
                          }
                        },
                        _vm._l(_vm.SystemConstants.U8C_AREAS, function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.confirmPush }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.pushAddCustomerDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }